import { useSelector } from "react-redux";
import danger from "../../Assets/Images/danger.svg";
import Analytics from "./Components/Analytics";
import Overview from "./Components/Overview";
import ProfitableTime from "./Components/ProfitableTime";
import Statistics from "./Components/Statistics";

function ChallengePerformance() {
  const { challengeStageInfo } = useSelector(
    (state) => state.ChallengeOverviewReducer
  );

  return (
    <>
      {challengeStageInfo?.status == "BREACHED" && (
        <div className="flex items-center gap-4 bg-red-opacity w-full p-4 rounded-lg  mb-4">
          <img src={danger} className="w-6 h-6" alt="danger" />
          <div>
            <div className="flex flex-col gap-2 text-red">
              Disqualification Notice: Rule Breached
            </div>
            <div className="text-red opacity-50">
              Reason: {challengeStageInfo?.breachReason}
              <span className="text-grey  text-xs">
                {"("}
                {new Date(challengeStageInfo?.updatedAt).toLocaleDateString(
                  "en-US",
                  {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  }
                )}
                {")"}
              </span>
            </div>
          </div>
        </div>
      )}
      <Overview />
      <div className="flex gap-4  pb-8 mid:flex-row flex-col mt-8 items-stretch ">
        <ProfitableTime />
        <div className="flex gap-4  sm:flex-row flex-col mid:w-[50%] w-full ">
          <Statistics />
          <Analytics />
        </div>
      </div>
    </>
  );
}

export default ChallengePerformance;
